import {
  ASSIGNMENT_ACTIVITY_LIST,
  GET_ACTIVITY_ASSIGNMENT,
  EMBEDDED_ASSIGNMENT_ACTIVITY_LIST,
  RESET_REDUX_STATE,
  GET_ACTIVITY_ASSIGNMENT_BY_CONFIGURATION_ID,
} from "../constants";

const initialState = {
  allActivityList: [],
  activityAssignmentData: undefined,
  embeddedAllActivityList: undefined,
  activityAssignmentDataByConfigurationId: undefined,
};

const assignmentReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ASSIGNMENT_ACTIVITY_LIST: {
      return {
        ...state,
        allActivityList: payload,
      };
    }

    case GET_ACTIVITY_ASSIGNMENT: {
      return {
        ...state,
        activityAssignmentData: payload,
      };
    }

    case EMBEDDED_ASSIGNMENT_ACTIVITY_LIST: {
      return {
        ...state,
        embeddedAllActivityList: payload,
      };
    }

    case GET_ACTIVITY_ASSIGNMENT_BY_CONFIGURATION_ID: {
      return {
        ...state,
        activityAssignmentDataByConfigurationId: payload,
      };
    }

    case RESET_REDUX_STATE: {
      return initialState;
    }

    default:
      return state;
  }
};

export default assignmentReducer;
